// Segnalazione al backend degli errori non gestiti del browser (ErrorBoundary,
// window.onerror, unhandledrejection). Prima un crash di render lasciava la
// pagina bianca senza traccia da nessuna parte: ora finisce nei log PM2 con
// utente, pagina e versione del bundle (POST /api/client-errors).
//
// Best effort: mai un'eccezione da qui, dedup degli stessi messaggi, massimo
// 10 invii per caricamento di pagina.

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
const APP_VERSION = process.env.REACT_APP_BUILD_VERSION || "__DEV__";
const MAX_REPORTS = 10;

const inviati = new Set();
let count = 0;

export function reportClientError({ source, message, stack, componentStack }) {
    try {
        const key = `${source}|${message}|${(stack || "").slice(0, 200)}`;
        if (inviati.has(key) || count >= MAX_REPORTS) return;
        inviati.add(key);
        count++;
        const token = localStorage.getItem("token");
        fetch(`${API_URL}/client-errors`, {
            method: "POST",
            keepalive: true,
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify({
                source,
                message: String(message || "").slice(0, 4000),
                stack: String(stack || "").slice(0, 4000),
                componentStack: String(componentStack || "").slice(0, 4000),
                url: window.location.pathname + window.location.search,
                appVersion: APP_VERSION,
            }),
        }).catch(() => {});
    } catch (_) {
        // mai propagare
    }
}

// Errori globali fuori dall'albero React (handler, promise, script).
export function installGlobalErrorReporting() {
    const ignora = /^ResizeObserver loop/;
    window.addEventListener("error", (e) => {
        if (!e?.message || ignora.test(e.message)) return;
        reportClientError({ source: "window.onerror", message: e.message, stack: e.error?.stack });
    });
    window.addEventListener("unhandledrejection", (e) => {
        const r = e?.reason;
        // Richieste annullate/timeout di axios non sono crash.
        if (r?.code === "ERR_CANCELED" || r?.code === "ECONNABORTED") return;
        reportClientError({
            source: "unhandledrejection",
            message: r?.message || String(r),
            stack: r?.stack,
        });
    });
}
